import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import createNotification from '../../../../utils/createNotification';
import { FlowOfFunds, WireTransferCategory } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface ConfirmWireSentArg {
    engagementId: number;
    category: WireTransferCategory;
    sourceRowId: number | null;
    paymentDate: Date | null;
    confirmed: boolean;
}

export const ConfirmWireSent = createAsyncThunk(
    'flowOfFunds/confirmWireSent',
    async (arg: ConfirmWireSentArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/FlowOfFunds/${arg.engagementId}/WireTransfers/ConfirmSent`,
                {
                    category: arg.category,
                    sourceRowId: arg.sourceRowId,
                    paymentDate: arg.paymentDate
                        ? moment(arg.paymentDate).format('YYYY-MM-DD')
                        : null,
                    confirmed: arg.confirmed,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to confirm the wire was sent');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification(
                'There was an error while confirming the wire was sent.',
                'error'
            );
            throw error;
        }
    }
);
